import {LOB_LIST} from "./type";

const initalState = {
  lobList: [],
};

const lobReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOB_LIST:
      return {
        ...state,
        lobList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default lobReducer;
